import React, { useEffect, useState } from "react";
import "./css/RegisterPage.css";
import logo from "../../img/elma.png";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axiosInstance from "../../api/axiosInstance";
import {
  FaUser,
  FaLock,
  FaEnvelope,
  FaPhone,
  FaStore,
  FaMapMarkerAlt,
  FaClipboardList,
} from "react-icons/fa";

// import PremiumBackground from "../kuyumcu/components/PremiumBackground";

const RegisterPage = () => {
  const [showCard, setShowCard] = useState(false);

  // Hesap
  const [username, setUsername] = useState("");

  // Kişisel
  const [isim, setIsim] = useState("");
  const [soyisim, setSoyisim] = useState("");

  // Firma
  const [firmaAdi, setFirmaAdi] = useState("");
  const [firmaIl, setFirmaIl] = useState("");
  const [firmaIlce, setFirmaIlce] = useState("");
  const [firmaAdres, setFirmaAdres] = useState("");

  // Güvenlik
  const [password, setPassword] = useState("");
  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

  // İletişim
  const [email, setEmail] = useState("");
  const [telefon, setTelefon] = useState("");

  // Plan
  const [selectedPlan, setSelectedPlan] = useState(null);

  // UI
  const [error, setError] = useState("");
  const [animateError, setAnimateError] = useState(false);
  const [errorKey, setErrorKey] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setShowCard(true), 200);
    return () => clearTimeout(t);
  }, []);

  const triggerError = (msg) => {
    setError(msg);
    setErrorKey((prev) => prev + 1);
    setAnimateError(true);
    setTimeout(() => setAnimateError(false), 250);
  };

  const validateForm = () => {
    if (!username.trim()) return "Kullanıcı adı boş olamaz.";
    if (!isim.trim()) return "İsim boş olamaz.";
    if (!soyisim.trim()) return "Soyisim boş olamaz.";
    if (!firmaAdi.trim()) return "Firma adı boş olamaz.";

    const passRegex = /^(?=.*[A-Za-z])(?=.*\d).{8,}$/;
    if (!passRegex.test(password))
      return "Şifre en az 8 karakter olmalı ve harf + sayı içermelidir.";
    if (password !== passwordConfirm) return "Şifreler birbiriyle eşleşmiyor.";

    // Email zorunlu değil denmedi, ama mevcut koda göre validasyon var:
   const mailRegex = /^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/;
   if (email && !mailRegex.test(email)) {
     return "Geçerli bir e-posta adresi girin.";
   }

    const phoneRegex = /^\d{10,11}$/;
    if (!phoneRegex.test(telefon)) return "Telefon 10–11 haneli olmalıdır.";

    if (!selectedPlan) return "Lütfen bir plan seçin.";

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validateMsg = validateForm();
    if (validateMsg) {
      triggerError(validateMsg);
      return;
    }

    // Backend tarafında nasıl bekliyorsan ona göre:
    const uyelikTip = "KUYUMCU";

    try {
      const resp = await axiosInstance.post("/auth/register", {
        kullaniciAdi: username.trim(),
        password,
        email: email.trim(),
        telefon: telefon.trim(),
        uyelikTip,

        isim: isim.trim(),
        soyisim: soyisim.trim(),

        firmaAdi: firmaAdi.trim(),
        firmaIl: firmaIl.trim(),
        firmaIlce: firmaIlce.trim(),
        firmaAdres: firmaAdres.trim(),

        kuyumcuTipi: selectedPlan,
      });

      const data = resp.data;

      alert("Kayıt başarılı! Giriş sayfasına yönlendiriliyorsunuz...");
      navigate("/login");
    } catch (err) {
      const msg =
              err?.response?.data?.message ||
              err?.response?.data ||
              "Sunucuya ulaşılamadı.";
            triggerError(msg);
    }
  };

  const RequiredBadge = () => <span className="required-badge">Zorunlu</span>;

  return (
    <div className="register-page page-content">

{/*       <PremiumBackground/> */}
      <div className={`register-card ${showCard ? "show" : ""}`}>
        <img
          src={logo}
          alt="Prosetwin Logo"
          className="register-logo"
          onClick={() => navigate("/")}
          style={{ cursor: "pointer" }}
        />

        {error && (
          <div key={errorKey} className={`error-box ${animateError ? "shake" : ""}`}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          {/* HESAP */}
          <div className="form-section account-section">
            <div className="section-title">
              <FaUser className="section-icon" />
              <span>Hesap Bilgileri</span>
            </div>

            <div className="section-body">
              <div className="input-group">
                <label className="field-label">
                  Kullanıcı Adı <RequiredBadge />
                </label>
                <div className="input-wrapper">
                  <FaUser className="input-icon" />
                  <input
                    type="text"
                    placeholder="Kullanıcı adınızı girin"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    autoComplete="username"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* KİŞİSEL */}
          <div className="form-section personal-section">
            <div className="section-title">
              <FaUser className="section-icon" />
              <span>Kişisel Bilgiler</span>
            </div>

            <div className="section-body">
              <div className="input-group">
                <label className="field-label">
                  İsim <RequiredBadge />
                </label>
                <div className="input-wrapper">
                  <FaUser className="input-icon" />
                  <input
                    type="text"
                    placeholder="Adınızı girin"
                    value={isim}
                    onChange={(e) => setIsim(e.target.value)}
                    required
                    autoComplete="given-name"
                  />
                </div>
              </div>

              <div className="input-group">
                <label className="field-label">
                  Soyisim <RequiredBadge />
                </label>
                <div className="input-wrapper">
                  <FaUser className="input-icon" />
                  <input
                    type="text"
                    placeholder="Soyadınızı girin"
                    value={soyisim}
                    onChange={(e) => setSoyisim(e.target.value)}
                    required
                    autoComplete="family-name"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* FİRMA */}
          <div className="form-section firma-section">
            <div className="section-title">
              <FaStore className="section-icon" />
              <span>Firma Bilgileri</span>
            </div>

            <div className="section-body">
              <div className="input-group">
                <label className="field-label">
                  Firma Adı <RequiredBadge />
                </label>
                <div className="input-wrapper">
                  <FaStore className="input-icon" />
                  <input
                    type="text"
                    placeholder="Firma adını girin"
                    value={firmaAdi}
                    onChange={(e) => setFirmaAdi(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="input-group">
                <label className="field-label">Firma İl</label>
                <div className="input-wrapper">
                  <FaMapMarkerAlt className="input-icon" />
                  <input
                    type="text"
                    placeholder="Örn: İstanbul"
                    value={firmaIl}
                    onChange={(e) => setFirmaIl(e.target.value)}
                  />
                </div>
              </div>

              <div className="input-group">
                <label className="field-label">Firma İlçe</label>
                <div className="input-wrapper">
                  <FaMapMarkerAlt className="input-icon" />
                  <input
                    type="text"
                    placeholder="Örn: Fatih"
                    value={firmaIlce}
                    onChange={(e) => setFirmaIlce(e.target.value)}
                  />
                </div>
              </div>

              <div className="input-group">
                <label className="field-label">Firma Adres</label>
                <div className="input-wrapper">
                  <FaMapMarkerAlt className="input-icon" />
                  <input
                    type="text"
                    placeholder="Adres"
                    value={firmaAdres}
                    onChange={(e) => setFirmaAdres(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* GÜVENLİK */}
          <div className="form-section security-section">
            <div className="section-title">
              <FaLock className="section-icon" />
              <span>Güvenlik</span>
            </div>

            <div className="section-body">
              <div className="input-group">
                <label className="field-label">
                  Şifre <RequiredBadge />
                </label>
                <div className="input-wrapper">
                  <FaLock className="input-icon" />
                  <input
                    type={showPassword ? "text" : "password"}
                    placeholder="Şifrenizi girin"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength={8}
                    pattern="^(?=.*[A-Za-z])(?=.*\d).{8,}$"
                    autoComplete="new-password"
                  />
                  <span
                    className="toggle-password"
                    onClick={() => setShowPassword((v) => !v)}
                    role="button"
                    tabIndex={0}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>

              <div className="input-group">
                <label className="field-label">
                  Şifre Tekrar <RequiredBadge />
                </label>
                <div className="input-wrapper">
                  <FaLock className="input-icon" />
                  <input
                    type={showPasswordConfirm ? "text" : "password"}
                    placeholder="Şifrenizi tekrar girin"
                    value={passwordConfirm}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    required
                    minLength={8}
                    autoComplete="new-password"
                  />
                  <span
                    className="toggle-password"
                    onClick={() => setShowPasswordConfirm((v) => !v)}
                    role="button"
                    tabIndex={0}
                  >
                    {showPasswordConfirm ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* İLETİŞİM */}
          <div className="form-section contact-section">
            <div className="section-title">
              <FaEnvelope className="section-icon" />
              <span>İletişim</span>
            </div>

            <div className="section-body">
              <div className="input-group">
                <label className="field-label">E-posta</label>
                <div className="input-wrapper">
                  <FaEnvelope className="input-icon" />
                  <input
                    type="email"
                    placeholder="E-posta adresinizi girin"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                  />
                </div>
              </div>

              <div className="input-group">
                <label className="field-label">
                  Telefon <RequiredBadge />
                </label>
                <div className="input-wrapper">
                  <FaPhone className="input-icon" />
                  <input
                    type="tel"
                    placeholder="5321234567"
                    value={telefon}
                    onChange={(e) => setTelefon(e.target.value)}
                    required
                    inputMode="numeric"
                    pattern="^\d{10,11}$"
                    autoComplete="tel"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* PLAN + BUTON */}
          <div className="form-section plan-section">
            <div className="section-title">
              <FaClipboardList className="section-icon" />
              <span>Plan Seçimi</span>
            </div>

            <div className="section-body">
              <div className="plan-container">
                <div
                  className={`plan-card ${selectedPlan === "ATOLYE_KUYUMCU" ? "selected" : ""}`}
                  onClick={() => setSelectedPlan("ATOLYE_KUYUMCU")}
                  role="button"
                  tabIndex={0}
                >
                  <h4>Kuyumcu</h4>
                  <p>Atölye</p>
                </div>

                <div
                  className={`plan-card ${selectedPlan === "VITRIN_KUYUMCU" ? "selected" : ""}`}
                  onClick={() => setSelectedPlan("VITRIN_KUYUMCU")}
                  role="button"
                  tabIndex={0}
                >
                  <h4>Kuyumcu</h4>
                  <p>Vitrin</p>
                </div>
              </div>

              <button type="submit" className="register-btn">
                Kayıt Ol
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterPage;
